import {History} from 'history';
import {get} from 'lodash-es';

import {IRequestFormEntityMeta, selectMetadata, setMetadata} from 'entities/metadata';
import {EEntityType} from 'shared/constants/entities';
import {ECommonMessages} from 'shared/constants/messages';
import {showMessageFromResponse} from 'shared/utils';
import {TAppState, TDispatch} from 'store/config/types';
import {getBlankForm} from 'utils/common';

import {selectEntityData} from '../data';
import {resetData, resetLoadedData, setData} from '../data/data-actions';
import {requestFormApi} from './request-form.api';
import {ERequestStatuses} from './request-form.constants';
import {getEntityNameFromMetadata, requestMeta} from './request-form.utils';

export const REQUEST_STATUS_CHANGED_TEXT = 'Статус запроса изменен';
const createFormActions = (entityType: EEntityType = EEntityType.FORM) => (dispatch: TDispatch) => {
    const setFormMeta = (metadata: IRequestFormEntityMeta) => (
        dispatch(setMetadata({
            entityName: getEntityNameFromMetadata(metadata),
            entityType,
            metadata,
        }))
    );
    const setFormData = (metadata: IRequestFormEntityMeta, data: Record<string, any>) => (
        dispatch(setData({
            entityName: getEntityNameFromMetadata(metadata),
            entityType,
            data,
        }))
    );
    const setMetaAndData = (metadata: IRequestFormEntityMeta, data: Record<string, any>) => {
        setFormMeta(metadata);
        setFormData(metadata, data);
    };
    const resetFormData = (entityName: string) => {
        dispatch(resetData({entityType, entityName, loading: false}));
    };
    const resetAllFormData = (entityNames: string[]) => {
        entityNames.forEach(name => resetFormData(name));
    };

    return {
        setMeta: setFormMeta,
        setData: setFormData,
        resetData: resetFormData,
        resetAllFormData,
        setMetaAndData,
    };
};
const createFormSelectors = (entityType: EEntityType = EEntityType.FORM) => (
    state: TAppState, defaultEntityName: string,
) => {
    const getCurrentMeta = (
        entityName: string = defaultEntityName,
    ) => selectMetadata(entityName, entityType)(state);
    const getCurrentData = (
        entityName: string = defaultEntityName,
    ) => selectEntityData(entityName, entityType)(state);
    return {
        getCurrentMeta,
        getCurrentData,
    };
};
export const formButtonsActions = (() => {
    const api = requestFormApi;
    const entityType = EEntityType.FORM;
    const getDefaultFormMeta = (entityName: string) => requestMeta.getDefaultByEntityName(entityName);
    const createUrlForViewingForm = (entityName: string, id: string = '') => `/${entityName}/${id}`;
    const createSelectors = createFormSelectors(entityType);
    const createActions = createFormActions(entityType);

    const openFormById = (entityName: string, linkField: string, history: History) => async (
        getState: () => TAppState,
    ) => {
        const selectors = createSelectors(getState(), entityName);
        const data = selectors.getCurrentData() as Record<string, any>;
        const newUrl = createUrlForViewingForm(entityName, data[String(linkField)]);

        history.push(newUrl);
    };
    /**
     * Открыть дочернюю форму.
     */
    const openChildFormForCreating = (
        entityNameForChild: string, history: History, params?: Record<string, any>,
    ) => async (dispatch: TDispatch) => {
        const actions = createActions(dispatch);
        const currentMeta = getDefaultFormMeta(entityNameForChild);
        const linkField = String(currentMeta.linkField) || 'id';
        const defaultData = await api.getDataForChildForm(params);
        const blankData = getBlankForm(currentMeta.fields);
        const currentData = {
            ...blankData,
            ...defaultData,
        };
        actions.setMetaAndData(currentMeta, currentData);

        const newUrl = createUrlForViewingForm(entityNameForChild, currentData[linkField]);
        // POSSIBLE_PROBLEM может нужен будет push
        history.replace(newUrl);
    };

    const changeStatusAndUpdateForm = (
        entityName: string, status: ERequestStatuses, linkField: string,
    ) => async (dispatch: TDispatch, getState: () => TAppState) => {
        try {
            const selectors = createSelectors(getState(), entityName);
            const data = selectors.getCurrentData() as Record<string, any>;
            const id = get(data, linkField);

            const statusChangeMessage = await api.status.changeStatus(status, id);
            showMessageFromResponse({
                response: statusChangeMessage,
                isError: false,
                customMessage: ECommonMessages.REQUEST_STATUS_CHANGED,
            });

            dispatch(resetLoadedData(entityName, EEntityType.FORM));
        } catch (error) {
            showMessageFromResponse({response: error.response, isError: true});
        }
    };

    return {
        changeStatusAndUpdateForm,
        openFormById,
        openChildFormForCreating,
    };
})();
